import { EnvironmentEnum } from './index';

export default {
  ENVIRONMENT: EnvironmentEnum.DEVELOPMENT,
  API_URL: process.env.REACT_APP_API_URL || 'http://localhost:3030',
  WS_URL: 'localhost:3030',
  TICKET_ID_PREFIX: 'HAUL-',
  FMCSA: {
    LINK_FOR_CHECK:
      'https://nationalregistry.fmcsa.dot.gov/search-medical-examiners?as=true&range=10',
  },
  HAULSAFE_PHONE_NUMBER: '(479) 342-4808',
  SEGMENT_ID: 'OZR9qfFoqiuuaoDjkEMpZrdPI8Ufe6GE',
  LOCALHOST_FLEET: process.env.REACT_APP_LOCALHOST_FLEET || 'jbhunt',
  LOGS_LEVEL: process.env.REACT_APP_LOG_LEVEL || 'debug',
  LOGS_PROVIDERS: ['console'],
  SENTRY_DSN: process.env.REACT_APP_SENTRY_DSN || '',
};
